export class StoreService {
    private static instance: StoreService = null;

    private store: Map<string, any> = new Map<string, any>();

    private constructor() {
    }

    public static getInstance(): StoreService {
        if (StoreService.instance == null) {
            StoreService.instance = new StoreService();
        }
        return StoreService.instance;
    }

    public setValue(key: string, value: any) {
        this.store.set(key, value);
    }

    public getValue(key: string): any {
        return this.store.get(key);
    }

    public deleteValue(key: string) {
        this.store.delete(key);
    }

    public clear() {
        this.store.clear();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/store/store.service.ts